import { render, staticRenderFns } from "./Availability.vue?vue&type=template&id=ae0fbb96&"
import script from "./Availability.vue?vue&type=script&lang=js&"
export * from "./Availability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/pp-weberbuero/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae0fbb96')) {
      api.createRecord('ae0fbb96', component.options)
    } else {
      api.reload('ae0fbb96', component.options)
    }
    module.hot.accept("./Availability.vue?vue&type=template&id=ae0fbb96&", function () {
      api.rerender('ae0fbb96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/Availability.vue"
export default component.exports